
export default function Services() {
  const services = [
    {
      icon: "ri-flashlight-line",
      title: "Dépannage urgent",
      description: "Le dépannage électrique urgent est avant tout un service rendu à nos clients. Notre mission : trouver la solution la plus fiable en cas de panne, avec un diagnostic rapide. Le temps de recherche de la panne et le déplacement sont généralement assurés dans les 30 minutes suivant votre appel.",
      image: "https://static.readdy.ai/image/c67d8bfa9f904100cebe9adf1f31e7a9/ae7409a03baebf010d3f09b0ea3845dc.png"
    },
    {
      icon: "ri-shield-check-line",
      title: "Mise aux normes",
      description: "Nous intervenons pour la mise en conformité des installations électriques et le dépannage de réseaux auprès des particuliers et professionnels : habitations, bureaux, locaux commerciaux. Avec plus de 30 ans d'expérience, vous avez la garantie d'une installation conforme et d'un travail de qualité.",
      image: "https://public.readdy.ai/ai/img_res/2e4a7fb0344d0aea5a8c6b9498d01ae2.jpg"
    },
    {
      icon: "ri-dashboard-line",
      title: "Tableaux électriques",
      description: "Nous mettons tout en œuvre pour assurer votre sécurité ainsi que celle de vos biens : Pose de tableaux électriques, Déplacement et raccordement, Mise en sécurité, Ajout de départs pour de nouveaux équipements, Mise en conformité lors d'un emménagement ou d'une rénovation.",
      image: "https://static.readdy.ai/image/c67d8bfa9f904100cebe9adf1f31e7a9/aa48402128306aa5494642fef02cfd33.png"
    },
    {
      icon: "ri-home-heart-line",
      title: "Rénovation électrique",
      description: "Dépannage électrique (prises, interrupteurs, tableau), Mise aux normes de l'installation électrique, Ajout de prises électriques, Mise à la terre, Fourniture et pose de radiateurs électriques.",
      image: "https://readdy.ai/api/search-image?query=Electrical%20renovation%20in%20cozy%20family%20home%2C%20new%20outlets%20and%20wiring%20installation%2C%20comfortable%20living%20space%2C%20professional%20electrical%20upgrade%2C%20warm%20residential%20interior%2C%20modern%20electrical%20fittings%20in%20welcoming%20environment&width=400&height=300&seq=service-renovation&orientation=landscape"
    }
  ];

  return (
    <section id="services" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-6 font-nunito">
            Nos services
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto font-nunito">
            Des solutions électriques complètes pour votre tranquillité d'esprit
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-6xl mx-auto">
          {services.map((service, index) => (
            <div key={index} className="bg-stone-50 rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow">
              <div className="aspect-video bg-cover bg-center" style={{ backgroundImage: `url('${service.image}')` }}></div>
              <div className="p-8">
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center mr-4">
                    <i className={`${service.icon} text-xl text-red-600`}></i>
                  </div>
                  <h3 className="text-2xl font-bold text-gray-800 font-nunito">{service.title}</h3>
                </div>
                <p className="text-gray-600 leading-relaxed font-nunito">{service.description}</p>
                <div className="mt-6">
                  <a
                    href="tel:0610143936"
                    className="inline-flex items-center text-red-600 font-semibold hover:text-red-700 transition-colors cursor-pointer font-nunito"
                  >
                    <i className="ri-phone-line mr-2"></i>
                    Appelez-nous
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
